import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.9565 3.75C16.4527 4.0125 17.9093 4.47705 19.289 5.13185C21.6658 8.73459 22.8468 12.7979 22.4107 17.4863C20.8048 18.7173 19.0062 19.6522 17.0939 20.25C16.6633 19.651 16.2825 19.0151 15.9558 18.3493C16.5782 18.1082 17.1791 17.8108 17.7512 17.4606C17.6026 17.3562 17.4556 17.2397 17.3119 17.1182C13.9473 18.7586 10.0526 18.7584 6.68803 17.1182C6.54599 17.2312 6.39898 17.3476 6.24868 17.4606C6.81984 17.8103 7.41942 18.107 8.04079 18.3476C7.71375 19.0137 7.33303 19.6502 6.90276 20.25C4.99205 19.6498 3.19481 18.7146 1.58918 17.4846C1.21754 13.4418 1.96081 9.34075 4.70267 5.13527C6.08384 4.48031 7.54131 4.01473 9.03843 3.75C9.24308 4.12945 9.4284 4.51986 9.59341 4.91952C11.1872 4.67055 12.8078 4.67055 14.4016 4.91952C14.5666 4.51986 14.7517 4.12945 14.9565 3.75ZM16.1257 11.25C15.0698 11.25 14.25 12.0964 14.25 13.1287C14.25 14.1609 15.096 15 16.1257 15C17.1734 15 17.9817 14.1609 17.9997 13.1287C18.0177 12.0964 17.1816 11.25 16.1257 11.25ZM8.6224 11.25C7.56907 11.25 6.75 12.0964 6.75 13.1287C6.75 14.1609 7.59856 15 8.62568 15C9.67245 15 10.4817 14.1609 10.4997 13.1287C10.5177 12.0964 9.67573 11.25 8.6224 11.25Z",
  fill: "#5865F2"
}, null, -1);
const _hoisted_2 = [
  _hoisted_1
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_2);
}
const icV2LogoDiscordColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2LogoDiscordColor as default
};
